import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'japanDate',
  standalone: true,
})
export class JapanDatePipe implements PipeTransform {
  transform(date: number | string | Date): string {
    if (!date) {
      return '-';
    }
    moment.locale('ja');
    return moment(date).format('YYYY/MM/DD');
  }
}
